import { render, staticRenderFns } from "./UpdateRetailer.vue?vue&type=template&id=104494c9&"
import script from "./UpdateRetailer.vue?vue&type=script&lang=js&"
export * from "./UpdateRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports